"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_IPFS_URL = exports.NETWORK_CONFIGS = void 0;
const constants_1 = require("./constants");
const mainnet_json_1 = __importDefault(require("@subql/contract-sdk/publish/mainnet.json"));
const kepler_json_1 = __importDefault(require("@subql/contract-sdk/publish/kepler.json"));
const testnet_json_1 = __importDefault(require("@subql/contract-sdk/publish/testnet.json"));
exports.NETWORK_CONFIGS = {
    [constants_1.SQNetworks.MAINNET]: {
        defaultEndpoint: constants_1.RPC_ENDPOINTS.mainnet,
        sdkOptions: { deploymentDetails: mainnet_json_1.default },
        gql: (0, constants_1.gqlEndpoints)(constants_1.SQNetworks.MAINNET),
    },
    [constants_1.SQNetworks.KEPLER]: {
        defaultEndpoint: constants_1.RPC_ENDPOINTS.kepler,
        sdkOptions: { deploymentDetails: kepler_json_1.default },
        gql: (0, constants_1.gqlEndpoints)(constants_1.SQNetworks.KEPLER),
    },
    [constants_1.SQNetworks.TESTNET]: {
        defaultEndpoint: constants_1.RPC_ENDPOINTS.testnet,
        sdkOptions: { deploymentDetails: testnet_json_1.default },
        gql: (0, constants_1.gqlEndpoints)(constants_1.SQNetworks.TESTNET),
    },
};
exports.DEFAULT_IPFS_URL = constants_1.IPFS_URLS.metadata;
//# sourceMappingURL=config.js.map